/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from "@solana/kit";
import {
  getBaseFeeParametersDecoder,
  getBaseFeeParametersEncoder,
  getDynamicFeeParametersDecoder,
  getDynamicFeeParametersEncoder,
  type BaseFeeParameters,
  type BaseFeeParametersArgs,
  type DynamicFeeParameters,
  type DynamicFeeParametersArgs,
} from "./index.js";

/** Information regarding fee charges */
export type PoolFeeParameters = {
  /** Base fee */
  baseFee: BaseFeeParameters;
  /** padding */
  padding: Array<number>;
  /** dynamic fee */
  dynamicFee: Option<DynamicFeeParameters>;
};

export type PoolFeeParametersArgs = {
  /** Base fee */
  baseFee: BaseFeeParametersArgs;
  /** padding */
  padding: Array<number>;
  /** dynamic fee */
  dynamicFee: OptionOrNullable<DynamicFeeParametersArgs>;
};

export function getPoolFeeParametersEncoder(): Encoder<PoolFeeParametersArgs> {
  return getStructEncoder([
    ["baseFee", getBaseFeeParametersEncoder()],
    ["padding", getArrayEncoder(getU8Encoder(), { size: 3 })],
    ["dynamicFee", getOptionEncoder(getDynamicFeeParametersEncoder())],
  ]);
}

export function getPoolFeeParametersDecoder(): Decoder<PoolFeeParameters> {
  return getStructDecoder([
    ["baseFee", getBaseFeeParametersDecoder()],
    ["padding", getArrayDecoder(getU8Decoder(), { size: 3 })],
    ["dynamicFee", getOptionDecoder(getDynamicFeeParametersDecoder())],
  ]);
}

export function getPoolFeeParametersCodec(): Codec<
  PoolFeeParametersArgs,
  PoolFeeParameters
> {
  return combineCodec(
    getPoolFeeParametersEncoder(),
    getPoolFeeParametersDecoder(),
  );
}
